export const GET_COURSE_LISTING_CONST = 'GET_COURSE_LISTING_CONST'

export const CLEAR_COURSE_LIST = 'CLEAR_COURSE_LIST'
